export const MFA_ACTIONS = {
  WITHDRAW: 'WITHDRAW',
  CANCEL_EVENT: 'CANCEL_EVENT',
  END_LIVE: 'END_LIVE',
  DISABLE_MFA: 'DISABLE_MFA',
  UPDATE_SETTLEMENT_ACCOUNT: 'UPDATE_SETTLEMENT_ACCOUNT',
} as const;

export type MfaAction = (typeof MFA_ACTIONS)[keyof typeof MFA_ACTIONS];
